import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer id="footer" className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row gy-4">
            {/* Company Info */}
            <div className="col-lg-5 col-md-12 footer-info">
                <img src="/img/logo/sdtechlogo.png" alt="SDtech Solutions Logo" style={{ height: "100px" }} /> <br />
              {/* <Link to="/" className="logo d-flex align-items-center">
                <span style={{ fontWeight: "bold", fontSize: "1.4rem", color: "#0070f3" }}>SDtech</span>
                <span style={{ fontWeight: "500", fontSize: "1.4rem", color: "#333", marginLeft: "4px" }}>Solutions</span>
              </Link> */}
              <p style={{ marginTop: "15px" }}>
                SDtech Solutions is a full-service technology company specializing in software development, web and mobile applications, digital marketing, cloud services, and IT consulting. We partner with businesses to deliver innovative solutions that drive measurable growth and lasting competitive advantages.
              </p>
              <div className="social-links mt-3"> 
                <a href="https://twitter.com/sdtechsolutions" target="_blank" rel="noreferrer" className="twitter">
                  <i className="bi bi-twitter "  />
                </a>
                <a href="https://facebook.com/sdtechsolutions" target="_blank" rel="noreferrer" className="facebook">
                  <i className="bi bi-facebook" />
                </a>
                <a href="https://instagram.com/sdtechsolutions" target="_blank" rel="noreferrer" className="instagram">
                  <i className="bi bi-instagram" />
                </a>
                <a href="https://linkedin.com/company/sdtechsolutions" target="_blank" rel="noreferrer" className="linkedin">
                  <i className="bi bi-linkedin" />
                </a>
                <a href="https://youtube.com/@sdtechsolutions" target="_blank" rel="noreferrer" className="youtube">
                  <i className="bi bi-youtube" />
                </a>
              </div>
            </div>

            {/* Useful Links */}
            <div className="col-lg-2 col-6 footer-links">
              <h4 className="text-primary">Quick Links</h4>
              <ul>
                <li><i className="bi bi-chevron-right" /> <Link to="/">Home</Link></li>
                <li><i className="bi bi-chevron-right" /> <Link to="/about">About Us</Link></li>
                <li><i className="bi bi-chevron-right" /> <Link to="/services">Services</Link></li>
                <li><i className="bi bi-chevron-right" /> <Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><i className="bi bi-chevron-right" /> <Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            {/* Services Links */}
            <div className="col-lg-2 col-6 footer-links">
              <h4 className="text-primary" >Our Services</h4>
              <ul>
                <li><i className="bi bi-chevron-right" /> <Link to="/services/software-development">Software Development</Link></li>
                <li><i className="bi bi-chevron-right" /> <Link to="/services/web-development">Web Development</Link></li>
                <li><i className="bi bi-chevron-right" /> <Link to="/services/mobile-app-development">Mobile Apps</Link></li>
                <li><i className="bi bi-chevron-right" /> <Link to="/services/seo">SEO Services</Link></li>
                <li><i className="bi bi-chevron-right" /> <Link to="/services/social-media-marketing">Social Media</Link></li>
                <li><i className="bi bi-chevron-right" /> <Link to="/services/cloud-services">Cloud Services</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="col-lg-3 col-md-12 footer-contact text-center text-md-start">
              <h4 className="text-primary">Contact Us</h4>
              <p >
                BSF Colony Sai Town , Nainod
                <br />
                Indore, Madhya Pradesh 453112
                <br />
                India
                <br /><br />
                <strong className="text-primary">Phone:</strong>{" "}
                <a href="tel:+917000191398" className="text-primary">+91 7000191398</a>
                <br />
                <strong className="text-primary" >Email:</strong>{" "}
                <a href="mailto:info@sdtechsolutions.com" className="text-primary">info@sdtechsolutions.com</a>
                <br />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="copyright" style={{ textAlign: "center", padding: "20px 0" }}>
          © {new Date().getFullYear()} <strong><span>SDtech Solutions</span></strong>. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}